import { CustomHeaderTemplate } from './custom-header.enum';

export interface IGridColumn {
  dataField: string;
  captionKey: string;
  dataType?: string;
  customHeaderTemplate?: CustomHeaderTemplate;
  alignment?: string;
  format?: string;
  allowEditing?: boolean;
  required?: boolean;
  forbidDecimalComma?: boolean;
  min?: number; // For min max header template
  max?: number; // For min max header template
  definedByUser?: boolean; // For min max header template
  width?: string | number;
}
